import React from "react";
import { Container, Button } from "react-bootstrap";
import { easeOut, motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import "../../homepage/homepage.css";

import Avatarone from "../../../assets/Avatarone.png";
import Avatartwo from "../../../assets/Avatartwo.svg";
import Avatarthree from "../../../assets/Avatarthree.png";

const CircularCard = ({ imageSrc }) => {
  return (
    <div className="circular-card">
      <div className="circular-image">
        <img src={imageSrc} alt="Card" />
      </div>
    </div>
  );
};

function Contactus() {
  const buttonstyle = {
    paddingTop: 0.6 + "rem",
    paddingBottom: 0.6 + "rem",
    paddingLeft: 1.1 + "rem",
    paddingRight: 1.1 + "rem",
    fontWeight: "400",
    backgroundColor: "#F36F2E",
    borderRadius:25+'px',
  };

  return (
    <Container fluid id="contact">
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        whileInView={{ y: -5, opacity: 1 }}
        transition={{ duration: 0.3, delay: 0.4, timingFunction: easeOut }}
        viewport={{ once: true }}
      >
        <Container className="Contactus">
          <center>
            <div className="card-stack">
              <div className="middle-card">
                <img src={Avatartwo} alt="Middle Card" />
              </div>
              <CircularCard imageSrc={Avatarone} alt="Avatarimage" />
              <CircularCard imageSrc={Avatarthree} alt="Avatarimage" />
            </div>
            <br />
            <div style={{ marginTop: 2 + "rem" }}>
              <h5
                style={{
                  color: "#101828",
                  fontSize: 1.4 + "rem",
                  fontWeight: "500",
                }}
              >
                Contact Us
              </h5>
              <p className="contacttext" style={{ color: "#667085", fontSize: 0.86 + "rem" }}>
              Ready to take your logistics to the next level? Reach 
              out to us now and let's start optimizing your transportation 
              needs together. We're here to make logistics easier for you.{" "}
              </p>

              <NavLink to="/contactus" >
              <Button
                style={buttonstyle}
                variant="primary"
                className="button"
                size="md"
              >
                Get in touch
              </Button>
              </NavLink>
            </div>
          </center>
        </Container>
      </motion.div>
    </Container>
  );
}

export default Contactus;
